import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { SectionHeading } from './SectionHeading';
const avatarTones = ['bg-coral-wash text-coral-deep', 'bg-gold-wash text-gold-deep', 'bg-leaf-wash text-leaf-deep', 'bg-navy/10 text-navy'];
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="bg-paper" data-id="element-349" data-mp="3azt57ofmmxjh">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-350" data-mp="36ziphk218srf">
        <SectionHeading id="testimonials-title" title="Christen entdecken einen einfacheren Weg, ihren Glauben weiterzugeben" data-id="element-351" data-mp="31zwap66k34gi" />
        <ul className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-352" data-mp="2x005j3m4h6zd">
          {testimonials.map((t, i) => <li key={t.name} className="flex flex-col rounded-2xl bg-white p-7 shadow-card ring-1 ring-cream-line sm:p-8" data-id="element-353" data-mp="2s2i6q61tk853" data-mpi={i}>
              <QuoteIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-354" data-mp="v855jl98aqwz" />
              <p className="mt-4 font-display text-2xl leading-tight text-navy" data-id="element-355" data-mp="qa3qrciu5drb">„{t.headline}“</p>
              <blockquote className="mt-3 flex-1 leading-relaxed text-ink-soft" data-id="element-356" data-mp="h5oq3c5zm87y">„{t.quote}“</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-cream-line pt-5" data-id="element-357" data-mp="m62pk5tiw9ud">
                <span className={`flex h-11 w-11 items-center justify-center rounded-full font-display text-xl ${avatarTones[i % avatarTones.length]}`} data-id="element-358" data-mp="78k4bdg20ero">
                  {t.name.charAt(0)}
                </span>
                <div data-id="element-359" data-mp="zxhcgnqjwv6p">
                  <p className="font-extrabold text-navy" data-id="element-360" data-mp="zx7sphw3nk9g">{t.name}</p>
                  <p className="text-sm text-ink-mute" data-id="element-361" data-mp="14uhgyu7r5pvp">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}